import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../zodios/client";

export function ChromeAccessToken() {
  const { data: token } = useQuery({
    queryKey: ["chrometoken", "layout"],
    queryFn: async () => await apiClient.createChromeToken(undefined),
    staleTime: Infinity,
  });

  return (
    <span id="chromeCode" style={{ display: "none" }}>
      {token?.token}
    </span>
  );
}
